export default __webpack_public_path__ + "static/media/decent@3x.45bd466f.png";